import React from 'react';
import { useCart } from '../context/CartContext';
import { motion } from 'framer-motion';

const CartItemsList = () => {
  const { cartItems, updateQuantity, removeFromCart } = useCart();

  const handleQuantityChange = (id, newQuantity) => {
    updateQuantity(id, Math.max(newQuantity, 1));
  };

  return (
    <>
      {/* Cart Table Headers */}
      <div className="row border-bottom pb-2 mb-3 fw-bold d-none d-md-flex">
        <div className="col-md-5">Product</div>
        <div className="col-md-2 text-center">Quantity</div>
        <div className="col-md-2 text-center">Unit Price</div>
        <div className="col-md-2 text-end">Total</div>
        <div className="col-md-1 text-end">Remove</div>
      </div>

      {/* Cart Items */}
      {cartItems.map((item, index) => (
        <motion.div
          className="row border-bottom py-3 align-items-center"
          key={item.id}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.05 }}
        >
          <div className="col-md-5">
            <h6>{item.name}</h6>
            <small className="text-muted">{item.description || 'No description'}</small>
          </div>
          <div className="col-md-2 text-center">
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                disabled={item.quantity <= 1}
              >
                −
              </button>
              <span className="mx-2">{item.quantity}</span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          <div className="col-md-2 text-center">
            ${ (item.price ?? 0).toFixed(2) }
          </div>
          <div className="col-md-2 text-end">
            ${ ((item.price ?? 0) * (item.quantity ?? 0)).toFixed(2) }
          </div>
          <div className="col-md-1 text-end">
            <button className="btn btn-sm btn-danger" onClick={() => removeFromCart(item.id)}>×</button>
          </div>
        </motion.div>
      ))}
    </>
  );
};

export default CartItemsList;